<template>
  <div>
    <nav-breadcrumb :menu="[{label: '还款管理'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :multipleSelectionOperation="listMultipleSelectionOperation"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        @viewItem = 'viewItem'
        @payPledgeFinancing = 'payPledgeFinancing'
        @rePayPledgeFinancing = "rePayPledgeFinancing"
      ></data-table>
    </el-row>
    <el-dialog title="贷款放款" :visible.sync="dialogVisible">
      <pay-pledge-financing-component
        :loan-account-list="loanAccountList"
        :pay-account-list="payAccountList"
        :pay-transaction-id="payTransactionId"
        @done="payPledgeFinancingDone"
      ></pay-pledge-financing-component>
    </el-dialog>
  </div>
</template>

<script>
  import PayPledgeFinancingComponent from '../../components/PayFinancingComponent'
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ServerAdminFinancingRepaymentList',
    data() {
      return {
        transactionStatus: this.$route.query['fi.transactionStatus'],
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '流水号',
            field: 're__reference'
          },
          {
            name: '还款方式',
            field: 're__channel',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '交易时间',
            field: 're__repayDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '客户姓名',
            field: 'u__customerName'
          },
          {
            name: '金额(元)',
            field: 're__totalAmount',
            formatter:  (r,c,v)=> {
              return formatMoney(v)
            }
          },
          {
            name: '还款账户',
            field: 'cj__outboundAccountDesc',
          },
          {
            name: '收款账户',
            field: 'cj__inboundAccountDesc',
          },
          {
            name: '备注',
            field: 're__remarks',
          },
          {
            name: '状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
              return Status2CN('Financing_'+ v)
            }
          },
          {
            name: '操作',
            opts:[
              {
                clickHandler: (index, row)=>{
                  this.$router.push({path: 'RepayDetail?cj.reference='+ row.cj__reference})
                },
                class: 'el-icon-info',
                name: '查看'
              },
            ]
          }
        ],
        listMultipleSelectionOperation: [
        ],
        payTransactionId: '',
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        filters: {
          form: {
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            re__repayDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '贷款编号',
              component: 'el-input',
              field: 'fi__transactionNo'
            },
            {
              label: '交易时间',
              component: 'date-range-picker',
              field: 're__repayDate'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerRepaymentList()
          }
        },
        actions: [
          {
            label: '导出',
            class: 'el-icon-download el-button--primary',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/financing/Repayment.List?format=xlsx',
                query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            // 'xlist.search.fi.transactionStatus': this.$route.query['fi.transactionStatus'],
            // 'xlist.search.fi.transactionStatus.op': 'in',
            // 'xlist.sort.dataField': 'fi.transactionDate',
            // 'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerRepaymentList()
      }
    },
    mounted() {
      this.getCustomerRepaymentList()
      this.getBankAccountList()
    },
    components: {
      DataTable,
      PayPledgeFinancingComponent
    },
    methods: {
      getCustomerRepaymentList: function () {
        xhr.getCustomerRepaymentList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      },
      getBankAccountList: function () {
        xhr.getBankAccountList({},res=>{
          try{
            if(res.data.status == 'success') {
              this.payAccountList = res.data.data||[]
            }
          }catch (e) {

          }
        })
      },
      getCustomerBankAccountList: function (customerId) {
        xhr.getCustomerBankAccountList({
            'c.customerId': customerId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.loanAccountList = res.data.data||[]
              }
            }catch (e) {

            }
          })
      },
      viewItem: function (index, row) {
        try {
          this.$router.push({path: 'Detail?fi.transactionId='+ row.fi__transactionId})
        }
        catch (e) {

        }
      },
      payPledgeFinancing: function (index, row) {
        this.dialogVisible = true
        this.payTransactionId = row.fi__transactionId
        this.getCustomerBankAccountList(row.fi__customerId)
      },
      payPledgeFinancingDone: function () {
        this.dialogVisible = false
        this.getCustomerFinancingList()
      },
      rePayPledgeFinancing: function (index, row) {
        this.$router.push({
          path: 'Repay?fi.transactionId='+ row.fi__transactionId+'&re.repaymentId='+row.re__repaymentId
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingRepaymentList.vue